import React from 'react';
import NumberField from "../NumberField";

const CurrencyInput = (props) => {
  const {
    label,
    labelIcon,
    required,
    initialValue,
    initialUnitValue,
    currencies,
    disabled,
    onValueChange,
    onUnitCHange,
    minValue,
    maxValue,
    step,
  } = props;

  return (
    <NumberField
      initialValue={initialValue}
      initialUnitValue={initialUnitValue}
      label={label}
      labelIcon={labelIcon}
      disabled={disabled}
      required={required}
      units={currencies}
      onValueChange={onValueChange}
      onUnitCHange={onUnitCHange}
      decimalScale={2}
    />
  );
}

export default CurrencyInput;